export default __webpack_public_path__ + "static/media/yuting_.cdb7d875.ico";